import { makeSearchProps, newSearchData, Search } from '../interfaces/search'
import axios from 'axios'
import {
  Search as PrismaSearch,
  SearchStatus,
  SearchType,
} from '@prisma/client'

export const customFetcher = async ([url, params]: string[]) => {
  const assembledUrl = url + params
  return fetch(assembledUrl).then((res) => res.json())
}

export const fetcher = (args: string) => fetch(args).then((res) => res.json())

export const getSearchDataById = async (
  searchId: string
): Promise<Search | null> => {
  try {
    const { data } = await axios.get(`/api/search/${searchId}`)
    return data
  } catch (err) {
    console.error(err)
    return null
  }
}

export const isUrlValid = async (url: string): Promise<boolean | string> => {
  try {
    const { data } = await axios.post('/api/search/domain/validation', {
      url,
    })
    return data.success
  } catch (error: any) {
    return false
  }
}

export const pageTitle = async (
  url: string,
  captchaToken?: string | null
): Promise<null | string> => {
  try {
    const { data } = await axios.post('/api/search/domain/pageTitle', {
      url,
      captchaToken,
    })

    return data.title
  } catch (error: any) {
    return null
  }
}

export const getDomainCount = async (): Promise<number> => {
  const { data } = await axios.get(`/api/search/domain/domainCount`)
  return data
}

export const getSearchCount = async (): Promise<number> => {
  const { data } = await axios.get(`/api/search/searchCount`)
  return data
}

export const getExportCount = async (): Promise<number> => {
  const { data } = await axios.get(`/api/search/export`)
  return data
}

export const getUsedDomains = async (): Promise<string[]> => {
  const { data } = await axios.get(`/api/search/domain`)
  return data
}

export const addNewExport = async (exportType: string): Promise<boolean> => {
  try {
    const { status } = await axios.post(`/api/search/export`, {
      exportType,
    })
    return status === 200
  } catch (err) {
    console.error(err)
    return false
  }
}

const makeSearchAttempt = async (
  newSearchQuery: Omit<newSearchData, 'userId' | 'hasBeenOpened'>
): Promise<boolean> => {
  const { status } = await axios.post(`/api/search`, {
    searchData: newSearchQuery,
  })
  return status === 200
}

export const makeSearch = async ({
  searchType,
  url,
  keyword,
  language = 'en',
  country = 'us',
  onSuccess = () => {},
  onError = () => {},
}: makeSearchProps) => {
  try {
    const newSearchQuery: any = {
      keyword: keyword,
      searchType: searchType,
      language: language.length ? language.toLowerCase() : 'en',
      country: country.length ? country.toLowerCase() : 'us',
      url: url,
    }
    const status = await makeSearchAttempt(newSearchQuery)
    if (!status) {
      throw new Error('Search failed')
    }
    onSuccess()
  } catch (e) {
    console.error(e)
    onError()
  }
}

export const isReportsInProgress = (
  searchData: PrismaSearch[] | undefined,
  activeSearchType: SearchType
) => {
  if (searchData) {
    return searchData.some(
      ({ searchType, status }) =>
        searchType === activeSearchType &&
        (SearchStatus.RUNNING === status || SearchStatus.PENDING === status)
    )
  } else {
    return false
  }
}

export const updateSearchById = async (
  searchId: string,
  updateQuery: Partial<PrismaSearch>
): Promise<PrismaSearch> => {
  return await (
    await axios.put(`/api/search/${searchId}`, { updateQuery })
  ).data
}

export function checkHttps(url: string) {
  if (url.length > 0) {
    const properUrl = url.startsWith('https://') ? url : `https://${url}`

    return properUrl
  }
  return url
}
